import React from "react";
import { reportClientError } from "../utils/telemetry";

type Props = React.PropsWithChildren<{ resetKey?: string }>;
type State = { failed: boolean };

export default class AppErrorBoundary extends React.Component<Props, State> {
    state: State = { failed: false };

    static getDerivedStateFromError(): State {
        return { failed: true };
    }

    componentDidUpdate(prevProps: Props) {
        if (this.state.failed && prevProps.resetKey !== this.props.resetKey) {
            this.setState({ failed: false });
        }
    }

    componentDidCatch(error: Error, info: React.ErrorInfo) {
        // Keep a visible stack in local/prod browser consoles; telemetry may be disabled.
        console.error("[BLACKSPACE_RENDER_ERROR]", error, info.componentStack);
        reportClientError(error, info.componentStack || "");
    }

    render() {
        if (!this.state.failed) return this.props.children;
        return (
            <main className="grid min-h-screen place-items-center bg-black p-6 text-white">
                <section role="alert" className="w-full max-w-lg rounded-lg border border-red-900 bg-neutral-950 p-6 text-center">
                    <h1 className="text-xl font-black">Blackspace could not render this view</h1>
                    <p className="mt-2 text-sm text-neutral-400">Your account data is untouched. Reload the app to reconnect.</p>
                    <button type="button" onClick={() => window.location.reload()} className="mt-5 min-h-11 rounded-md bg-cyan-700 px-5 py-2 text-sm font-bold hover:bg-cyan-600">
                        Reload Blackspace
                    </button>
                </section>
            </main>
        );
    }
}
